// Midnight Clarity Color Palette
export const BASE = '#0F1419';           // Very dark background
export const SURFACE = '#1A2332';        // Card/surface background
export const LIGHT = '#F7F9FC';          // Text primary
export const MUTE = '#64748B';           // Text muted
export const FAINT = 'rgba(148, 163, 184, 0.12)';  // Border color
export const GHOST = '#94A3B8';          // Text secondary
export const GOLD = '#E8A849';           // Primary amber
export const EMBER = '#10B981';          // Success green
export const DEBIT_RED = '#ef4444';      // Debit / outgoing / spending
export const WARNING = '#F59E0B';        // Warning
export const SECONDARY = '#3B82F6';      // Secondary blue

// Neon Accents - For Data Only
export const NEON_TEAL = '#00FFCC';      // Debt Killed
export const NEON_RED = '#FF4D4D';       // High APR Warning
export const NEON_GOLD = '#FFD700';      // Daily Streak

// Extended palette
export const PRIMARY = '#E8A849';        // Amber primary
export const PRIMARY_DARK = '#D49A3D';   // Darker amber
export const PRIMARY_LIGHT = '#F2B85C';  // Lighter amber (hover)
export const ACCENT = '#10B981';         // Success green
export const ELEVATED = '#243044';       // Surface elevated
export const SUCCESS_SOFT = 'rgba(16, 185, 129, 0.15)';

export const DISPLAY = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";
export const BODY = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";
export const MONO = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";

export const TC = { bronze: '#cd7f32', silver: '#c0c0c0', gold: GOLD, legendary: '#a855f7' };

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

// Theme system - Midnight Clarity dark theme
export const THEMES = {
  dark: {
    base: '#0F1419', surface: '#1A2332', light: '#F7F9FC',
    mute: '#64748B', faint: 'rgba(148, 163, 184, 0.12)',
    ghost: '#94A3B8', gold: '#E8A849', ember: '#10B981',
    goldBg: 'rgba(232, 168, 73, 0.15)', goldBorder: 'rgba(232, 168, 73, 0.3)',
    emberBg: 'rgba(16, 185, 129, 0.15)', emberBorder: 'rgba(16, 185, 129, 0.3)',
    inputBg: '#1A2332', inputText: '#F7F9FC',
    secondary: '#3B82F6', textSecondary: '#94A3B8', warning: '#F59E0B',
    primary: '#E8A849', primaryDark: '#D49A3D', primaryLight: '#F2B85C',
    elevated: '#243044', successSoft: 'rgba(16, 185, 129, 0.15)',
  },
  light: {
    base: '#F7F9FC', surface: '#FFFFFF', light: '#0F1419',
    mute: '#64748B', faint: 'rgba(148, 163, 184, 0.2)',
    ghost: '#94A3B8', gold: '#D49A3D', ember: '#059669',
    goldBg: 'rgba(212, 154, 61, 0.12)', goldBorder: 'rgba(212, 154, 61, 0.35)',
    emberBg: 'rgba(5, 150, 105, 0.12)', emberBorder: 'rgba(5, 150, 105, 0.35)',
    inputBg: '#FFFFFF', inputText: '#0F1419',
    secondary: '#2563EB', textSecondary: '#64748B', warning: '#D97706',
    primary: '#D49A3D', primaryDark: '#B8862F', primaryLight: '#E8A849',
    elevated: '#F1F5F9', successSoft: 'rgba(5, 150, 105, 0.12)',
  },
};

export function applyTheme(theme) {
  const t = THEMES[theme] || THEMES.dark;
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  root.style.setProperty('--base', t.base);
  root.style.setProperty('--surface', t.surface);
  root.style.setProperty('--light', t.light);
  root.style.setProperty('--mute', t.mute);
  root.style.setProperty('--faint', t.faint);
  root.style.setProperty('--ghost', t.ghost);
  root.style.setProperty('--gold', t.gold);
  root.style.setProperty('--ember', t.ember);
  root.style.setProperty('--gold-bg', t.goldBg);
  root.style.setProperty('--gold-border', t.goldBorder);
  root.style.setProperty('--ember-bg', t.emberBg);
  root.style.setProperty('--ember-border', t.emberBorder);
  root.style.setProperty('--input-bg', t.inputBg);
  root.style.setProperty('--input-text', t.inputText);
  root.style.setProperty('--secondary', t.secondary);
  root.style.setProperty('--text-secondary', t.textSecondary);
  root.style.setProperty('--warning', t.warning);
  // Update meta theme-color
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.content = t.base;
}
